import { useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../services/api";

import logo from "../assets/logo.png";
import sideImage from "../assets/login-side.png";

export default function Login() {
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  // ==========================
  // LOGIN
  // ==========================
  const login = async () => {
    try {
      if (!mobile || !password) {
        return alert("Enter mobile & password");
      }

      setLoading(true);

      const res = await API.post("/login", {
        mobile: mobile.trim(),
        password,
      });

      const token = res.data.token;

      const user = {
        ...res.data.user,
        role: String(res.data.user.role || "")
          .toLowerCase()
          .trim(),
      };

      localStorage.setItem("token", token);
      localStorage.setItem("user", JSON.stringify(user));

      switch (user.role) {
        case "salesman":
          navigate("/sales");
          break;

        case "finance":
          navigate("/payouts");
          break;

        case "manager":
          navigate("/manager");
          break;

        case "ceo":
          navigate("/ceo/claims");
          break;

        default:
          navigate("/");
      }
    } catch (err) {
      console.log(err);

      alert(err.response?.data?.msg || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative min-h-screen overflow-hidden bg-gradient-to-br from-slate-100 via-indigo-50 to-blue-100 flex items-center justify-center px-4 py-8">

      {/* BACKGROUND GLOW */}
      <div className="absolute top-[-120px] left-[-120px] h-[380px] w-[380px] rounded-full bg-indigo-500/20 blur-3xl"></div>

      <div className="absolute bottom-[-120px] right-[-120px] h-[350px] w-[350px] rounded-full bg-blue-500/20 blur-3xl"></div>

      {/* MAIN CARD */}
      <div className="relative z-10 flex w-full max-w-7xl overflow-hidden rounded-[32px] border border-white/40 bg-white/70 shadow-2xl backdrop-blur-xl">

        {/* LEFT SIDE */}
        <div className="hidden lg:flex lg:w-[55%] bg-gradient-to-br from-indigo-600 to-indigo-700 p-14 items-center justify-center">

          <div className="max-w-xl text-center text-white">

            <img
              src={sideImage}
              alt="Illustration"
              className="mx-auto mb-10 w-full max-w-md"
            />

            <h1 className="text-5xl font-bold leading-tight mb-6">
              Sales Incentive
              <br />
              Management System
            </h1>

            <p className="text-lg leading-8 text-indigo-100">
              Manage claims, approvals, payouts and reports
              in one centralized smart platform.
            </p>

          </div>

        </div>

        {/* RIGHT SIDE */}
        <div className="w-full lg:w-[45%] bg-white px-6 py-10 sm:px-10 md:px-14 flex flex-col justify-center">

          {/* LOGO */}
          <div className="flex justify-center mb-6">

            <img
              src={logo}
              alt="Canon Logo"
              className="w-[180px] sm:w-[240px] object-contain"
            />

          </div>

          {/* TITLE */}
          <div className="text-center mb-10">

            <h2 className="text-4xl font-bold text-slate-800 mb-2">
              Welcome Back
            </h2>

            <p className="text-slate-500 text-sm">
              Sign in to continue your dashboard
            </p>

          </div>

          {/* MOBILE INPUT */}
          <div className="mb-6">

            <label className="mb-2 block text-sm font-semibold text-slate-700">
              Mobile Number
            </label>

            <input
              type="text"
              placeholder="923XXXXXXXXX"
              value={mobile}
              onChange={(e) =>
                setMobile(
                  e.target.value.replace(/[^0-9]/g, "")
                )
              }
              className="w-full rounded-2xl border border-slate-200 bg-slate-50 px-5 py-4 text-sm outline-none transition-all duration-300 focus:border-indigo-500 focus:bg-white focus:ring-4 focus:ring-indigo-100"
            />

          </div>

          {/* PASSWORD INPUT */}
          <div className="mb-6">

            <label className="mb-2 block text-sm font-semibold text-slate-700">
              Password
            </label>

            <input
              type="password"
              placeholder="Enter password"
              value={password}
              onChange={(e) =>
                setPassword(e.target.value)
              }
              className="w-full rounded-2xl border border-slate-200 bg-slate-50 px-5 py-4 text-sm outline-none transition-all duration-300 focus:border-indigo-500 focus:bg-white focus:ring-4 focus:ring-indigo-100"
            />

          </div>

          {/* OPTIONS */}
          <div className="mb-8 flex flex-wrap items-center justify-between gap-3 text-sm">

            <label className="flex items-center gap-2 text-slate-600">

              <input
                type="checkbox"
                className="h-4 w-4 rounded border-slate-300 text-indigo-600 focus:ring-indigo-500"
              />

              Remember me

            </label>

            <button className="font-semibold text-indigo-600 hover:text-indigo-700 transition">
              Forgot Password?
            </button>

          </div>

          {/* BUTTON */}
          <button
            onClick={login}
            disabled={loading}
            className="w-full rounded-2xl bg-gradient-to-r from-indigo-600 to-indigo-700 py-4 text-sm font-bold text-white shadow-lg shadow-indigo-500/30 transition-all duration-300 hover:scale-[1.02] hover:shadow-indigo-500/40 active:scale-[0.98] disabled:cursor-not-allowed disabled:opacity-70"
          >
            {loading ? "Please wait..." : "Log In"}
          </button>

        </div>

      </div>

    </div>
  );
}